import React from 'react';
import OngoingCampaignCardSkeleton from './OngoingCampaignCardSkeleton';

function OngoingCampaignSkeleton() {
  return (
    <section className="flex w-full gap-x-[10px] lg:gap-x-5">
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <OngoingCampaignCardSkeleton
            key={`ongoing-campaign-skeleton-${index}`}
          />
        ))}
    </section>
  );
}

export default OngoingCampaignSkeleton;
